/** @jsx isolateComponent */

import { keyframes } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../../theme';

const streakAnimation = keyframes({
  '0%': {
    transform: 'translateX(-100%)',
  },
  '100%': {
    transform: 'translateX(100%)',
  },
});

const Styles = labelStyles('SkeletonBlock', {
  root: [
    {
      backgroundColor: Colors.neutral200,
      overflow: 'hidden',
      position: 'relative',

      '&::before': {
        animation: `${streakAnimation} 1s ease-in-out infinite`,
        content: '""',
        background: `linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0))`,
        position: 'absolute',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
      },
    },
  ],
});

type Props = {
  /**
   * An aspect ratio to maintain for the element.
   * **Important:** This takes precedence over `height`.
   */
  aspectRatio?: number;
  /**
   * Border radius of the block.
   */
  borderRadius?: number | string;
  /**
   * Any valid CSS `height` value.
   */
  height?: number | string;
  /**
   * Any valid CSS `width` value.
   */
  width: number | string;
};

export const SkeletonBlock = (props: Props) => {
  const style = {
    borderRadius: props.borderRadius,
    width: props.width,
    paddingTop: props.aspectRatio
      ? `calc(${props.width} / ${props.aspectRatio})`
      : props.height,
  };
  return <div css={Styles.root} data-testid="SkeletonBlock" style={style} />;
};

SkeletonBlock.defaultProps = {
  borderRadius: 5,
  width: '100%',
};
